module.exports = new __parcel__URL__("celebrate.45e473a6.svg").toString();